var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsIconVimeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 38,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M4.501 3.5H36.5v32H4.501v-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#E9E9E9",
    strokeWidth: 3,
    d: "M34.306 10.624c-.312-1.461-1.093-2.423-2.539-2.892-1.442-.468-4.056-.282-5.882 1.05-1.868 1.361-2.976 3.728-3.363 5.233.919-.393 1.501-.48 2.439-.43.937.05 1.531.749 1.556 1.58.019.612-.013 1.168-.224 1.73-.676 1.793-1.733 3.529-2.977 5.047-.181.225-.399.431-.625.618-.638.519-1.176.38-1.587-.324-.338-.581-.563-1.181-.764-1.818-.775-2.479-1.049-5.053-1.487-7.595-.206-1.219-.438-2.486-1.125-3.554-.726-1.112-1.788-1.537-3.126-1.374-.919.112-2.307 1.092-2.989 1.649 0 0-3.5 2.928-5.113 4.46l1.325 1.686s1.119-.781 1.719-1.143c.357-.213.776-.257 1.076.012.281.244.6.562.769.881.356.669.7 1.367.92 2.086.823 2.767 1.592 5.54 2.362 8.326.393 1.423.868 2.76 1.75 3.972 1.208 1.662 2.475 2.043 4.432 1.344 1.587-.569 2.913-1.637 4.126-2.743 2.069-1.885 3.693-4.084 5.346-6.321 1.275-1.729 2.331-3.478 3.211-5.434.87-1.936 1.214-3.966.77-6.046h0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsIconVimeo);
export default __webpack_public_path__ + "static/media/sns-icon-vimeo.849b52d79afb1a0719d79500872e957f.svg";
export { ForwardRef as ReactComponent };